"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Directory = void 0;
var React = require("react");
var Grid_1 = require("../Grids/Grid");
var Paginator_1 = require("../Paginator/");
var Directory = function (_a) {
    var Headers = _a.Headers, Data = _a.Data, OnPageRequest = _a.OnPageRequest, CurrentPageNumber = _a.CurrentPageNumber, TotalPages = _a.TotalPages, DragLeaveHidesColumns = _a.DragLeaveHidesColumns, SaveLayout = _a.SaveLayout, SaveLayoutID = _a.SaveLayoutID;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid_1.Grid, { columnDefs: Headers, rowData: Data, defaultColDef: { resizable: true }, pagination: false, suppressPaginationPanel: true, suppressDragLeaveHidesColumns: !DragLeaveHidesColumns, SaveLayout: SaveLayout, SaveLayoutID: SaveLayoutID }),
        React.createElement(Paginator_1.Paginator, { OnPageRequest: OnPageRequest, TotalPages: TotalPages, CurrentPage: CurrentPageNumber })));
};
exports.Directory = Directory;
